export function expectedFieldIds(schema, record) {
  const ids = [];
  for (const item of schema || []) {
    if (item.structure_type === "regular") {
      ids.push(item.id);
      continue;
    }
    if (item.structure_type !== "repeat_group") continue;

    const fromSlot = item.repeat?.from_slot;
    const slotCount = Number.parseInt(fromSlot ? record?.[fromSlot] : NaN, 10);
    const existingIndexes = Object.keys(record || {})
      .map((key) => String(key).match(new RegExp(`^${item.id}\\[(\\d+)]\\.`)))
      .filter(Boolean)
      .map((match) => Number.parseInt(match[1], 10))
      .filter((index) => Number.isFinite(index) && index > 0);
    const count = Number.isFinite(slotCount) && slotCount > 0
      ? slotCount
      : Math.max(0, ...existingIndexes);

    for (let index = 1; index <= count; index += 1) {
      for (const field of item.fields || []) {
        ids.push(`${item.id}[${index}].${field.id}`);
      }
    }
  }
  return ids;
}

/**
 * Keep Verification Cards in the questionnaire's frozen field order even
 * when proposals arrive in participant-specific conversational order.
 * Unknown fields remain visible after canonical fields in their arrival order.
 */
export function orderReviewEditsBySchema(edits, schema, record) {
  const rank = new Map(
    expectedFieldIds(schema, record).map((fieldId, index) => [fieldId, index])
  );
  return (edits || [])
    .map((edit, arrivalIndex) => ({ edit, arrivalIndex }))
    .sort((left, right) => {
      const leftRank = rank.has(left.edit?.field_id)
        ? rank.get(left.edit.field_id)
        : Number.POSITIVE_INFINITY;
      const rightRank = rank.has(right.edit?.field_id)
        ? rank.get(right.edit.field_id)
        : Number.POSITIVE_INFINITY;
      return leftRank - rightRank || left.arrivalIndex - right.arrivalIndex;
    })
    .map(({ edit }) => edit);
}
